import * as React from 'react';
import MuiAvatar, { type AvatarProps as MuiAvatarProps } from '@mui/material/Avatar';
import Icon from '@mui/material/Icon';

export interface AvatarProps extends MuiAvatarProps {
  /** react-toolbox: image source */
  image?: string;
  /** react-toolbox: icon name (material icon) */
  icon?: React.ReactNode;
  /** react-toolbox: title/alt text */
  title?: string;
}

/**
 * Avatar wrapper - maps react-toolbox Avatar to MUI Avatar
 * - `image` maps to `src`
 * - `icon` (string) renders a material Icon as child
 * - `title` maps to `alt`
 */
const Avatar = React.forwardRef<HTMLDivElement, AvatarProps>(
  ({ image, icon, title, src, alt, children, ...rest }, ref) => {
    // Prefer explicit src/alt over legacy props
    const imageSrc = src || image;
    const altText = alt || title;

    // Determine children content
    let content = children;
    if (!content && icon) {
      content = typeof icon === 'string' ? <Icon>{icon}</Icon> : icon;
    }

    return (
      <MuiAvatar ref={ref} src={imageSrc} alt={altText} {...rest}>
        {content}
      </MuiAvatar>
    );
  },
);

Avatar.displayName = 'Avatar';

export default Avatar;
